/* Sourced Society | ss-product
   Gallery, zoom, popups, UK/EU sizes, add to bag (opens cart drawer),
   sticky bar, other colourways, recently viewed tracking. */
(() => {
  if (customElements.get('ss-product')) return;

  const MOBILE = window.matchMedia('(max-width: 989px)');
  const norm = (s) => String(s || '').toLowerCase().replace(/[‘’'"“”]/g, '').replace(/\s+/g, ' ').trim();

  class SsProduct extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-ss-form]');
      this.input = this.querySelector('[data-variant-input]');
      this.addBtn = this.querySelector('[data-add]');
      this.addText = this.querySelector('[data-add-text]');
      this.meta = JSON.parse((this.querySelector('[data-ss-meta]') || {}).textContent || '{}');
      this.optionLabel = this.meta.optionLabel || 'size';

      this.initGallery();
      this.initSizes();
      this.initSticky();
      this.addEventListener('click', (e) => this.onClick(e));
      if (this.form) this.form.addEventListener('submit', (e) => { e.preventDefault(); this.add(); });

      this.preselect();
      this.loadColourways();
      this.trackHeader();
      this.rememberView();
    }

    /* ---------------- Gallery ---------------- */
    initGallery() {
      this.slides = this.querySelector('[data-slides]');
      if (!this.slides) return;
      this.count = this.slides.children.length;
      this.bar = this.querySelector('[data-bar]');
      this.thumbs = [...this.querySelectorAll('[data-thumb]')];
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      const sync = () => {
        const i = Math.round(this.slides.scrollLeft / Math.max(1, this.slides.clientWidth));
        if (i === this.index) return;
        this.index = i;
        if (this.bar) this.bar.style.transform = 'translateX(' + (i * 100) + '%)';
        this.thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
        if (this.prev) this.prev.disabled = i <= 0;
        if (this.next) this.next.disabled = i >= this.count - 1;
        /* pause videos that are off screen */
        this.slides.querySelectorAll('video').forEach((v) => {
          const on = v.closest('[data-slide]').dataset.index == i;
          if (on) { v.play && v.play().catch(() => {}); } else { v.pause && v.pause(); }
        });
      };
      this.slides.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
      this.goTo = (i) => {
        const n = Math.max(0, Math.min(this.count - 1, i));
        this.slides.scrollTo({ left: n * this.slides.clientWidth, behavior: 'smooth' });
      };
      this.slides.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') this.goTo((this.index || 0) + 1);
        if (e.key === 'ArrowLeft') this.goTo((this.index || 0) - 1);
      });
      sync();
    }

    openZoom(i) {
      const lb = this.querySelector('[data-lb]');
      if (!lb || !lb.showModal) return;
      lb.showModal();
      document.documentElement.classList.add('ss-lock');
      const fig = lb.querySelector('[data-lb-item="' + i + '"]');
      if (fig) requestAnimationFrame(() => fig.scrollIntoView({ block: 'start' }));
      if (!lb.dataset.bound) {
        lb.dataset.bound = '1';
        lb.addEventListener('close', () => document.documentElement.classList.remove('ss-lock'));
      }
    }

    /* ---------------- Clicks ---------------- */
    onClick(e) {
      const t = e.target;
      const thumb = t.closest('[data-thumb]');
      if (thumb) { this.goTo(Number(thumb.dataset.thumb)); return; }
      if (t.closest('[data-prev]')) { this.goTo((this.index || 0) - 1); return; }
      if (t.closest('[data-next]')) { this.goTo((this.index || 0) + 1); return; }
      const zoom = t.closest('[data-zoom]');
      if (zoom) { this.openZoom(zoom.dataset.zoom); return; }
      if (t.closest('[data-lb-close]')) { this.querySelector('[data-lb]').close(); return; }

      const opener = t.closest('[data-ss-open]');
      if (opener) {
        const d = document.getElementById(opener.dataset.ssOpen);
        if (d && d.showModal) {
          d.showModal();
          document.documentElement.classList.add('ss-lock');
          if (!d.dataset.bound) {
            d.dataset.bound = '1';
            d.addEventListener('click', (ev) => { if (ev.target === d || ev.target.closest('[data-ss-close]')) d.close(); });
            d.addEventListener('close', () => document.documentElement.classList.remove('ss-lock'));
          }
        }
        return;
      }

      const tab = t.closest('[data-tab]');
      if (tab) { this.setTab(tab.dataset.tab); return; }

      const size = t.closest('[data-variant]');
      if (size) { this.select(size); return; }

      if (t.closest('[data-sticky-btn]')) {
        if (this.input && !this.input.hasAttribute('data-unselected') && !this.addBtn.disabled) {
          this.add();
        } else {
          const sizes = this.querySelector('[data-sizes]') || this.form;
          window.scrollTo({ top: sizes.getBoundingClientRect().top + window.scrollY - 140, behavior: 'smooth' });
          if (this.input && this.input.hasAttribute('data-unselected')) this.flagSize();
        }
      }
    }

    /* ---------------- Sizes ---------------- */
    initSizes() {
      this.sizes = [...this.querySelectorAll('[data-variant]')];
      this.label = this.querySelector('[data-size-label]');
      this.labelDefault = this.label ? this.label.textContent : '';
    }

    setTab(sys) {
      this.querySelectorAll('[data-tab]').forEach((b) => {
        const on = b.dataset.tab === sys;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', String(on));
      });
      this.sizes.forEach((s) => { if (s.dataset.sys === 'uk' || s.dataset.sys === 'eu') s.hidden = s.dataset.sys !== sys; });
      this.tab = sys;
    }

    preselect() {
      const id = new URL(window.location.href).searchParams.get('variant');
      if (!id) return;
      const btn = this.sizes.find((s) => s.dataset.variant === id);
      if (!btn) return;
      if (btn.dataset.sys === 'eu') this.setTab('eu');
      this.select(btn, false);
    }

    select(btn, push = true) {
      this.sizes.forEach((s) => s.setAttribute('aria-checked', String(s === btn)));
      this.input.value = btn.dataset.variant;
      this.input.removeAttribute('data-unselected');
      this.hideError();

      const available = btn.dataset.available === 'true';
      const price = this.querySelector('[data-price]');
      const was = this.querySelector('[data-was]');
      const save = this.querySelector('[data-save]');
      if (price) price.textContent = btn.dataset.price;
      if (was) { was.textContent = btn.dataset.was; was.hidden = !btn.dataset.was; }
      if (save) {
        const show = save.dataset.enabled === 'true' && Number(btn.dataset.pct) > 0;
        save.hidden = !show;
        if (show) save.textContent = 'Save ' + btn.dataset.pct + '%';
      }
      const sp = this.querySelector('[data-sticky-price]');
      if (sp) sp.textContent = btn.dataset.price;

      if (this.label) this.label.innerHTML = this.optionLabel + ': <span class="ss-pdp__labelval">' + btn.dataset.label + '</span>';

      this.addBtn.disabled = !available;
      this.addText.textContent = available ? 'Add to bag' : 'Sold out';
      const dyn = this.querySelector('[data-dyn]');
      if (dyn) dyn.toggleAttribute('data-locked', !available);
      const stickyBtn = this.querySelector('[data-sticky-btn]');
      if (stickyBtn) stickyBtn.textContent = available ? 'Add to bag' : 'Sold out';

      const stock = this.querySelector('[data-stock]');
      if (stock) {
        const low = Number(btn.dataset.low);
        if (available && low) {
          stock.textContent = low === 1 ? 'Last pair in this size' : 'Only ' + low + ' left in this size';
          stock.hidden = false;
        } else {
          stock.hidden = true;
        }
      }

      if (push) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', btn.dataset.variant);
        history.replaceState(history.state, '', url.toString());
      }
    }

    flagSize() {
      this.showError('Please select a ' + this.optionLabel + '.');
      const grid = this.querySelector('[data-sizes]');
      if (grid) { grid.classList.remove('is-shake'); void grid.offsetWidth; grid.classList.add('is-shake'); }
    }

    showError(msg) {
      const el = this.querySelector('[data-error]');
      if (el) { el.textContent = msg; el.hidden = false; }
    }

    hideError() {
      const el = this.querySelector('[data-error]');
      if (el) el.hidden = true;
    }

    /* ---------------- Add to bag ---------------- */
    async add() {
      if (this.input.hasAttribute('data-unselected')) { this.flagSize(); return; }
      if (this.addBtn.disabled || this.busy) return;
      this.busy = true;
      this.hideError();
      this.addBtn.classList.add('is-loading');
      try {
        const res = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(this.input.value), quantity: 1 }] })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to bag.');

        this.addBtn.classList.remove('is-loading');
        this.addBtn.classList.add('is-added');
        this.addText.textContent = 'Added to bag';
        setTimeout(() => { this.addBtn.classList.remove('is-added'); this.addText.textContent = 'Add to bag'; }, 2200);

        /* Refresh and open the Sourced Society cart drawer (falls back to the theme drawer) */
        if (window.SsCart) {
          window.SsCart.refresh().then(() => window.SsCart.open());
        } else {
          document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
          setTimeout(() => {
            const icon = document.querySelector('[data-js-cart-icon]');
            if (icon) icon.click();
          }, 450);
        }
      } catch (err) {
        this.addBtn.classList.remove('is-loading');
        this.showError(err.message);
      } finally {
        this.busy = false;
      }
    }

    /* ---------------- Sticky bar ---------------- */
    initSticky() {
      const cta = this.querySelector('[data-cta]');
      const bar = this.querySelector('[data-sticky]');
      if (!cta || !bar || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver(([entry]) => {
        const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.classList.toggle('is-sticky', past && MOBILE.matches);
        bar.setAttribute('aria-hidden', String(!past));
        const btn = bar.querySelector('[data-sticky-btn]');
        if (btn) btn.tabIndex = past ? 0 : -1;
      });
      io.observe(cta);
    }

    /* Keep the buy box under the header, which collapses while scrolling */
    trackHeader() {
      const hdr = document.querySelector('header.header');
      if (!hdr) return;
      let last = -1;
      let until = 0;
      let running = false;
      const measure = () => {
        const b = Math.max(0, Math.round(hdr.getBoundingClientRect().bottom));
        if (b !== last) { last = b; this.style.setProperty('--ss-header-h', b + 'px'); }
      };
      /* Follow the header frame by frame while scrolling and for a moment after,
         so the sticky gallery moves with the header's own animation, never after it */
      const loop = () => {
        measure();
        if (performance.now() < until) { requestAnimationFrame(loop); } else { running = false; }
      };
      const kick = () => {
        measure();
        until = performance.now() + 600;
        if (!running) { running = true; requestAnimationFrame(loop); }
      };
      window.addEventListener('scroll', kick, { passive: true });
      window.addEventListener('resize', kick);
      measure();
    }

    /* ---------------- Other colourways ---------------- */
    async loadColourways() {
      const wrap = this.querySelector('[data-ways]');
      const row = this.querySelector('[data-ways-row]');
      const model = this.dataset.model;
      if (!wrap || !row || !model || model.length < 4) return;
      try {
        const url = '/search/suggest.json?q=' + encodeURIComponent(model) +
          '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last&resources[options][fields]=title';
        const data = await (await fetch(url)).json();
        const products = (((data || {}).resources || {}).results || {}).products || [];
        const key = norm(model);
        const matches = products.filter((p) => p.handle !== this.dataset.handle && norm(p.title).startsWith(key));
        if (!matches.length) return;
        matches.forEach((p) => {
          const a = document.createElement('a');
          a.className = 'ss-pdp__way' + (p.available === false ? ' is-out' : '');
          a.href = p.url.split('?')[0];
          a.title = p.title;
          const src = (p.featured_image && p.featured_image.url) || p.image;
          if (src) {
            const img = document.createElement('img');
            img.src = src + (src.includes('?') ? '&' : '?') + 'width=200';
            img.alt = p.title;
            img.loading = 'lazy';
            a.appendChild(img);
          }
          row.appendChild(a);
        });
        wrap.hidden = false;
      } catch (e) { /* no colourways row */ }
    }

    /* ---------------- Recently viewed ---------------- */
    rememberView() {
      try {
        const key = 'ss-recent';
        const list = JSON.parse(localStorage.getItem(key) || '[]').filter((h) => h !== this.dataset.handle);
        list.unshift(this.dataset.handle);
        localStorage.setItem(key, JSON.stringify(list.slice(0, 12)));
      } catch (e) {}
    }
  }

  customElements.define('ss-product', SsProduct);
})();
